import { Observable, of } from 'rxjs';

let counter = 0;

export function increaseCounter(): Observable<number> {
  return of(++counter);
}
